import aboutPhoto from '../../../assets/about-photo.jpg';

export default function AboutSection() {
  return (
    <section className="bg-[#070B14] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <div className="aspect-[4/3] rounded-xl overflow-hidden">
              <img
                src={aboutPhoto}
                alt="Devstander team collaboration"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Text */}
          <div>
            <div className="flex items-center gap-2 mb-5">
              <span className="w-6 h-px bg-[#3B82F6]"></span>
              <span className="text-[#3B82F6] text-xs font-semibold uppercase tracking-widest">
                About Us
              </span>
            </div>
            <h2 className="font-display text-3xl lg:text-4xl font-bold text-white leading-tight mb-6 text-balance">
              Your Long-Term Technology Partner
            </h2>
            <p className="text-slate-400 leading-relaxed mb-5">
              Devstander is a software development company based in Warsaw, Poland.
              We specialize in building custom digital solutions for businesses across
              Europe and beyond – combining technical excellence with a deep understanding
              of our clients&apos; needs.
            </p>
            <p className="text-slate-400 leading-relaxed mb-8">
              We don&apos;t just ship code – we invest in understanding your business,
              your goals, and your users. Our goal is to be a reliable, long-term
              partner you can count on year after year.
            </p>

            <div className="grid grid-cols-2 gap-6">
              {[
                { value: '30+', label: 'Projects Delivered' },
                { value: '20+', label: 'Happy Clients' },
                { value: '15+', label: 'Years Experience' },
                { value: '100%', label: 'On-Time Delivery' },
              ].map((stat) => (
                <div key={stat.label} className="border-l-2 border-[#3B82F6] pl-4">
                  <p className="font-display text-2xl font-bold text-white">{stat.value}</p>
                  <p className="text-slate-500 text-sm mt-0.5">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
